import React, { useState, useEffect } from "react";

const FormAction = ({
  onSubmit,
  onUpdate,
  onCancel,
  onRecover,
  onClosePo,
  onApprovedPay,
  onSubmitTax,
  onUpdatePaid,
  onViewSo,
  docStatus,
  docPaidStatus,
  docIsRec,
  mode,
  setMode,
  disabled,
  disabledInv,
  disabledPay,
  creditCustomer,
  soNo,
  footer,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // Event listener สำหรับปุ่มที่ลูกค้าต้องการ
  useEffect(() => {
    const handleKeyDown = (event) => {
      // ถ้า modal เปิดอยู่ สำหรับปุ่ม Enter และ ESC
      if (showModal) {
        if (event.key === 'Enter') {
          event.preventDefault();
          if (!isButtonDisabled) {
            handleConfirm();
          }
        } else if (event.key === 'Escape') {
          event.preventDefault();
          if (!isButtonDisabled) {
            setShowModal(false);
          }
        }
        return; 
      }

      // Modal ไม่เปิด
      if (event.key === 'F10') {
        event.preventDefault();
        
        if (isButtonDisabled) return;
        
        if (mode === "I") {
          handleShowModal("submit");
        } else if (mode === "U") {
          if (!disabled) {
            handleShowModal("update");
          }
        }
      } else if (event.key === 'Escape') {
        event.preventDefault();
        
        if (isButtonDisabled) return;
        
        if (typeof setMode === "function") {
          setMode("S");
        } else {
          window.location.reload();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mode, isButtonDisabled, disabled, setMode, showModal]);

  const handleShowModal = (action) => {
    // ถ้าเป็นการชำระเงิน ให้ข้าม Confirm Modal ไปเลย
    if (action === "approved") {
      setIsButtonDisabled(true);

      onApprovedPay();

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
    } else {
      setAction(action);
      setShowModal(true);
    }
  };

  const handleConfirm = () => {
    setShowModal(false);
    setIsButtonDisabled(true);

    if (action === "submit") onSubmit();
    if (action === "update") onUpdate();
    if (action === "recover") onRecover();
    if (action === "cancel") onCancel();
    if (action === "closePo") onClosePo();
    // if (action === 'approved') onApprovedPay();
    if (action === "tax") onSubmitTax();
    if (action === "updatePaid") onUpdatePaid();

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 5000);
  };

  const getActionText = () => {
    switch (action) {
      case "submit":
        return "บันทึกข้อมูล";
      case "update":
        return "แก้ไขข้อมูล";
      case "recover":
        return window.location.pathname === "/bill-of-lading"
          ? "คืนสถานะใบเบิก"
          : window.location.pathname === "/bill"
          ? "ส่งกลับแก้ไขใบวางบิล"
          : "ยกเลิกปิดงาน PO";
      case "cancel":
        return "ยกเลิกข้อมูล";
      case "closePo":
        return "ปิดใบ PO";
      case "approved":
        return "ชำระเงิน";
      case "tax":
        return "ยืนยันการสร้างใบกํากับภาษี";
      case "updatePaid":
        return "ชำระเงินแล้ว ";
      default:
        return "";
    }
  };

  return (
    <>
      <div style={{ marginBottom: "50px" }} />
      <div
        style={{
          position: footer ? "fixed" : "static",
          bottom: "0",
          left: "0",
          width: "100vw",
          backgroundColor: footer ? "#f8f9fa" : "transparent",
          zIndex: "500",
          padding: "10px 0",
          marginLeft: "-5px",
          boxShadow: footer ? "0 -2px 5px rgba(0, 0, 0, 0.1)" : "none",
        }}
      >
        <div className="row mt-2">
          {footer ? (
            <>
              <div className="col-2" />
              <div className="col-4">
                <button
                  onClick={() => handleShowModal("cancel")}
                  type="button"
                  hidden={
                    mode !== "U"
                  }
                  className="btn btn-lg shadow text-white"
                  style={{
                    marginLeft: "-70px",
                    backgroundColor: "#808080",
                    fontSize: "16px",
                  }}
                  disabled={disabled || docIsRec}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    `ยกเลิก${
                      {
                        "/deposit-document": "ใบมัดจำ",
                        "/purchase-request": "ใบขอซื้อ",
                        "/purchase-order": "ใบสั่งซื้อ",
                        "/product-receipt": "ใบรับสินค้า",
                        "/payment-voucher": "ใบสำคัญจ่าย",
                        "/bill-of-lading": "ใบเบิก",
                        "/icebox": "ใบยืมสินค้า",
                        "/technical-equip-form": "ใบเบิกอุปกรณ์ช่าง",
                        "/office-equip-form": "ใบเบิกวัสดุใช้ภายใน",
                        "/quotation": "ใบเสนอราคา",
                        "/order-product": "ใบออเดอร์สินค้า",
                        "/billofsale": "ใบขาย",
                        "/picking-list": "Picking List",
                        "/bill": "ใบวางบิล",
                        "/invoice": "ใบกำกับภาษี",
                        "/tax": "หนังสือหัก ณ ที่จ่าย",
                      }[window.location.pathname] || ""
                    }`
                  )}
                </button>
                {window.location.pathname === "/bill" && (
                  <button
                    onClick={() => handleShowModal("recover")}
                    type="button"
                    hidden={mode === "I" || docStatus === 1}
                    className="btn btn-lg w-30] shadow text-white"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "blue",
                      fontSize: "16px",
                    }}
                  >
                    ส่งกลับแก้ไข
                  </button>
                )}
              </div>

              <div className="col-6 text-end" style={{ marginLeft: "-15px" }}>
                <button
                  onClick={() => {
                    if (typeof setMode === "function") {
                      setMode("S");
                    } else {
                      window.location.reload();
                    }
                  }}
                  type="button"
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "black",
                    fontSize: "16px",
                  }}
                  disabled={isButtonDisabled}
                >
                  กลับหน้าค้นหา (ESC)
                </button>
                <button
                  onClick={() => handleShowModal("submit")}
                  type="button"
                  hidden={mode === "U"}
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "#EF6C00",
                    fontSize: "16px",
                  }}
                  disabled={isButtonDisabled}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    "บันทึก (F10)"
                  )}
                </button>
                {window.location.pathname === "/purchase-order" && (
                  <button
                    onClick={() => handleShowModal("recover")}
                    type="button"
                    hidden={mode === "I" || docStatus !== 4}
                    className="btn btn-lg w-25 shadow text-white"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "green",
                      fontSize: "16px",
                    }}
                    disabled={docStatus !== 4}
                  >
                    {isButtonDisabled ? (
                      <>
                        <i
                          className="fa fa-spinner fa-spin me-2"
                          style={{ fontSize: "20px", color: "#ffffff" }}
                          aria-hidden="true"
                        ></i>
                        โปรดรอ
                      </>
                    ) : (
                      "ยกเลิกปิดงาน PO"
                    )}
                  </button>
                )}
                <button
                  onClick={() => handleShowModal("approved")}
                  type="button"
                  hidden={
                    mode === "I" ||
                    docStatus !== 2 ||
                    window.location.pathname !== "/deposit-document"
                  }
                  className="btn btn-lg w-30 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "green",
                    fontSize: "16px",
                  }}
                  disabled={docStatus !== 2}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    "ยืนยันการชำระเงิน"
                  )}
                </button>
                {window.location.pathname === "/bill" &&
                  (docPaidStatus === 0 || docPaidStatus === 1) && (
                    // || (window.location.pathname === '/billofsale' && (docStatus === 1 || docStatus === 2) && !creditCustomer)
                    <button
                      onClick={() => handleShowModal("approved")}
                      type="button"
                      hidden={mode === "I"}
                      className="btn btn-lg w-30 shadow text-white"
                      style={{
                        marginLeft: "20px",
                        backgroundColor: "green",
                        fontSize: "16px",
                      }}
                      disabled={docStatus === 13 || disabledPay}
                    >
                      {isButtonDisabled ? (
                        <>
                          <i
                            className="fa fa-spinner fa-spin me-2"
                            style={{ fontSize: "20px", color: "#ffffff" }}
                            aria-hidden="true"
                          ></i>
                          โปรดรอ
                        </>
                      ) : window.location.pathname === "/billofsale" ? (
                        "แก้ไขการชำระเงิน"
                      ) : (
                        "ยืนยันการชำระเงิน"
                      )}
                    </button>
                  )}
                {/* {
                                    window.location.pathname === '/billofsale' && docStatus === 2 &&
                                    (
                                        <button
                                            onClick={() => handleShowModal('updatePaid')}
                                            type="button"
                                            hidden={mode === 'I'}
                                            className="btn btn-lg w-30 shadow text-white"
                                            style={{ marginLeft: '20px', backgroundColor: 'green', fontSize: '16px' }}
                                            disabled={docStatus === 13}
                                        >
                                            {isButtonDisabled ? (
                                                <>
                                                    <i
                                                        className="fa fa-spinner fa-spin me-2"
                                                        style={{ fontSize: '20px', color: '#ffffff' }}
                                                        aria-hidden="true"
                                                    ></i>
                                                    โปรดรอ
                                                </>
                                            ) : (
                                                'ยืนยันว่าชำระแล้ว'
                                            )}
                                        </button>
                                    )
                                } */}
                {/* {
                                    window.location.pathname === '/bill' && docStatus === 1 &&
                                    (
                                        <button
                                            onClick={() => handleShowModal('updatePaid')}
                                            type="button"
                                            hidden={mode === 'I'}
                                            className="btn btn-lg w-30 shadow text-white"
                                            style={{ marginLeft: '20px', backgroundColor: 'green', fontSize: '16px' }}
                                            disabled={docStatus === 13}
                                        >
                                            {isButtonDisabled ? (
                                                <>
                                                    <i
                                                        className="fa fa-spinner fa-spin me-2"
                                                        style={{ fontSize: '20px', color: '#ffffff' }}
                                                        aria-hidden="true"
                                                    ></i>
                                                    โปรดรอ
                                                </>
                                            ) : (
                                                'ยืนยันว่าชำระแล้ว'
                                            )}
                                        </button>
                                    )
                                } */}
                {/* {
                                    ((window.location.pathname === '/bill'
                                        && docStatus === 2 && localStorage.getItem('company') === '2') ||
                                        (window.location.pathname === '/billofsale' && localStorage.getItem('company') === '2'))
                                    && (
                                        <button
                                            onClick={() => handleShowModal('tax')}
                                            type="button"
                                            hidden={mode === 'I'}
                                            className="btn btn-lg w-30 shadow text-white"
                                            style={{ marginLeft: '20px', backgroundColor: 'purple', fontSize: '16px' }}
                                            disabled={disabledInv || docStatus === 13}
                                        >
                                            {isButtonDisabled ? (
                                                <>
                                                    <i
                                                        className="fa fa-spinner fa-spin me-2"
                                                        style={{ fontSize: '20px', color: '#ffffff' }}
                                                        aria-hidden="true"
                                                    ></i>
                                                    โปรดรอ
                                                </>
                                            ) : (
                                                'ออกใบกำกับภาษี'
                                            )}
                                        </button>
                                    )
                                } */}
                {window.location.pathname === "/quotation" && (
                  <>
                    {soNo ? (
                      <button
                        onClick={() => onViewSo()}
                        type="button"
                        className="btn btn-lg w-30 shadow text-white"
                        style={{
                          marginLeft: "20px",
                          backgroundColor: "blue",
                          fontSize: "16px",
                        }}
                        hidden={mode === "I"}
                      >
                        ดูใบขาย
                      </button>
                    ) : (
                      <button
                        onClick={() => handleShowModal("approved")}
                        type="button"
                        className="btn btn-lg w-30 shadow text-white"
                        style={{
                          marginLeft: "20px",
                          backgroundColor: "green",
                          fontSize: "16px",
                        }}
                        hidden={mode === "I" || docStatus === 13}
                      >
                        {isButtonDisabled ? (
                          <>
                            <i
                              className="fa fa-spinner fa-spin me-2"
                              style={{ fontSize: "20px", color: "#ffffff" }}
                              aria-hidden="true"
                            ></i>
                            โปรดรอ
                          </>
                        ) : (
                          "ยืนยันการชำระเงิน"
                        )}
                      </button>
                    )}
                  </>
                )}
                <button
                  onClick={() => handleShowModal("closePo")}
                  type="button"
                  hidden={
                    mode === "I" ||
                    docStatus !== 2 ||
                    window.location.pathname !== "/purchase-order"
                  }
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "red",
                    fontSize: "16px",
                  }}
                  disabled={docStatus !== 2}
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    "ปิดงานใบ PO"
                  )}
                </button>
                {window.location.pathname === "/bill-of-lading" && (
                  <button
                    onClick={() => handleShowModal("recover")}
                    type="button"
                    hidden={mode === "I" || docStatus !== 13}
                    className="btn btn-lg w-25 shadow text-white"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "green",
                      fontSize: "16px",
                    }}
                    disabled={docStatus !== 13}
                  >
                    คืนสถานะใบเบิก
                  </button>
                )}
                <button
                  onClick={() => handleShowModal("update")}
                  type="button"
                  hidden={
                    mode === "I" ||
                    mode === "FA" ||
                    mode === "FT" ||
                    mode === "BL" ||
                    docStatus === 4 ||
                    (window.location.pathname === "/quotation" &&
                      soNo &&
                      docStatus !== null)
                  }
                  className="btn btn-lg w-25 shadow text-white"
                  style={{
                    marginLeft: "20px",
                    backgroundColor: "#EF6C00",
                    fontSize: "16px",
                  }}
                  disabled={
                    isButtonDisabled ||
                    disabled ||
                    (window.location.pathname === "/quotation" &&
                      soNo &&
                      docStatus !== null)
                  }
                >
                  {isButtonDisabled ? (
                    <>
                      <i
                        className="fa fa-spinner fa-spin me-2"
                        style={{ fontSize: "20px", color: "#ffffff" }}
                        aria-hidden="true"
                      ></i>
                      โปรดรอ
                    </>
                  ) : (
                    "แก้ไข (F10)"
                  )}
                </button>
              </div>
            </>
          ) : (
            <div
              className="col text-center"
              style={{ display: "flex", justifyContent: "right" }}
            >
              <button
                onClick={() =>
                  handleShowModal(mode === "I" ? "submit" : "update")
                }
                type="button"
                className="btn btn-lg shadow text-white"
                style={{
                  width: "12%",
                  marginLeft: "20px",
                  backgroundColor: "#EF6C00",
                  fontSize: "16px",
                }}
                disabled={isButtonDisabled}
              >
                {isButtonDisabled ? (
                  <>
                    <i
                      className="fa fa-spinner fa-spin me-2"
                      style={{ fontSize: "20px", color: "#ffffff" }}
                      aria-hidden="true"
                    ></i>
                    โปรดรอ
                  </>
                ) : mode === "I" ? (
                  "บันทึก (F10)"
                ) : (
                  "แก้ไข (F10)"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                ยืนยันการ{getActionText()}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>คุณแน่ใจว่าต้องการดำเนินการ{getActionText()}หรือไม่?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#EF6C00",
                  fontSize: "16px",
                  position: "relative",
                  whiteSpace: "nowrap",
                }}
                onClick={handleConfirm}
                disabled={isButtonDisabled}
              >
                {isButtonDisabled ? (
                  <>
                    <i
                      className="fa fa-spinner fa-spin me-2"
                      style={{ fontSize: "20px", color: "#ffffff" }}
                      aria-hidden="true"
                    ></i>
                    กำลังโหลด
                  </>
                ) : (
                  "ยืนยัน (Enter)"
                )}
              </button>
              <button
                type="button"
                className="btn btn-lg w-30 shadow text-white"
                style={{ backgroundColor: "red", fontSize: "16px" }}
                onClick={() => setShowModal(false)}
                disabled={isButtonDisabled}
              >
                ยกเลิก (ESC)
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormAction;
